import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ServicesGrid() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(0);

  const services = [
    {
      title: 'Coches Siniestrados',
      description: 'Compramos vehículos con daños por accidente. Mejor precio garantizado.',
      image: 'https://public.readdy.ai/ai/img_res/76d11915bbcf6a770b9700e72e02e635.jpg',
      link: '/vender-coche-siniestro-barcelona'
    },
    {
      title: 'Coches Averiados',
      description: 'Vehículos con averías mecánicas o eléctricas. Tasación inmediata.',
      image: 'https://readdy.ai/api/search-image?query=broken%20down%20car%20with%20mechanical%20problems%20in%20professional%20garage%20clean%20white%20background%20front%20view%20modern%20workshop%20setting%20professional%20photography%20bright%20lighting%20high%20quality%20business%20style&width=800&height=600&seq=service002&orientation=landscape',
      link: '/vender-coche-averiado-barcelona'
    },
    {
      title: 'Coches Sin ITV',
      description: 'Compramos coches sin pasar la ITV. Proceso rápido y legal.',
      image: 'https://readdy.ai/api/search-image?query=old%20car%20without%20inspection%20in%20professional%20automotive%20facility%20clean%20white%20background%20three%20quarter%20view%20modern%20industrial%20setting%20professional%20photography%20bright%20lighting%20high%20quality%20business%20style&width=800&height=600&seq=service003&orientation=landscape',
      link: '/vender-coche-sin-itv-barcelona'
    },
    {
      title: 'Coches Accidentados',
      description: 'Compramos coches con cualquier tipo de daño por colisión. Pago inmediato.',
      image: 'https://readdy.ai/api/search-image?query=accident%20damaged%20vehicle%20collision%20impact%20car%20in%20professional%20automotive%20facility%20clean%20white%20background%20side%20angle%20view%20modern%20industrial%20setting%20professional%20photography%20bright%20lighting%20high%20quality%20business%20style&width=800&height=600&seq=service004&orientation=landscape',
      link: '/vender-coche-accidentado-barcelona'
    },
    {
      title: 'Tasación Gratuita',
      description: 'Descubre cuánto vale tu coche. Tasación sin compromiso en 24 horas.',
      image: 'https://readdy.ai/api/search-image?query=professional%20car%20valuation%20assessment%20expert%20inspecting%20vehicle%20with%20clipboard%20in%20modern%20automotive%20facility%20clean%20white%20background%20professional%20photography%20bright%20lighting%20high%20quality%20business%20style&width=800&height=600&seq=service005&orientation=landscape',
      link: '/tasacion-coche-barcelona'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-black text-[#1a2332] mb-4">
            Compramos Todo Tipo de Vehículos 🚗
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            No importa el estado de tu coche. En Desguace Barcelona ofrecemos la mejor tasación del mercado para cualquier vehículo en Barcelona y provincia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(0)}
              className={`relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
                hoveredCard === index ? 'md:scale-105 z-10' : 'md:scale-100'
              }`}
              style={{ height: '420px' }}
            >
              <img 
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover"
              />
              <div className={`absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent transition-all duration-300 ${
                hoveredCard === index ? 'from-black/90' : ''
              }`}></div>
              
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <h3 className="text-3xl font-bold text-white mb-3">{service.title}</h3>
                <p className="text-white/90 text-base mb-4 leading-relaxed">{service.description}</p>
                {service.link.startsWith('/') ? (
                  <Link
                    to={service.link}
                    className={`inline-flex items-center px-6 py-3 rounded-full font-medium transition-all ${
                      hoveredCard === index 
                        ? 'bg-white text-[#1a2332]' 
                        : 'border-2 border-white text-white bg-transparent'
                    }`}
                  >
                    Más información
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                ) : (
                  <a
                    href={service.link}
                    className={`inline-flex items-center px-6 py-3 rounded-full font-medium transition-all cursor-pointer ${
                      hoveredCard === index 
                        ? 'bg-white text-[#1a2332]' 
                        : 'border-2 border-white text-white bg-transparent'
                    }`}
                  >
                    Más información
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
